import { envConfig } from '../../config';
import { developmentAnalytics } from './adapters/development';
import { gtmAnalytics } from './adapters/gtm';
import { Analytics } from './analytics';

class AnalyticsManager {
  private analytics: Analytics[];

  constructor() {
    const { REACT_APP_ANALYTICS_DISABLED, REACT_APP_ENVIRONMENT } = envConfig;

    if (REACT_APP_ANALYTICS_DISABLED === 'true') {
      this.analytics = [];
    } else if (REACT_APP_ENVIRONMENT === 'production') {
      this.analytics = [gtmAnalytics];
    } else {
      this.analytics = [developmentAnalytics];
    }
  }

  get isInitialized() {
    return this.analytics.length > 0
      ? this.analytics.every((analytics) => analytics.isInitialized())
      : true;
  }

  initialize() {
    this.analytics.forEach((analytics) => analytics.initialize());
  }

  track(event: string, options?: Record<string, any>) {
    this.analytics.forEach((analytics) => analytics.track(event, options));
  }
}

export default AnalyticsManager;
